import { IdentifierCasing } from "@/apollo/types";
import { applyIdentifierCasing } from "@/features/data-warehouse-schemas";

/** Mirrors `defaultSchemaName` in the backend's `EltSyncAdditionalDestinationsService`; keep the two in sync. */
export function defaultDestinationSchemaName(
  syncSchemaName: string,
  syncCasing: IdentifierCasing | null | undefined,
  destinationCasing: IdentifierCasing | null | undefined,
) {
  const name =
    syncCasing === IdentifierCasing.Uppercase
      ? syncSchemaName.toLowerCase()
      : syncSchemaName;
  return applyIdentifierCasing(name, destinationCasing);
}
